export const namoNetraDialogTranslations = {
    en: {
        selectStatus: "Select Status",
        statusUpdateDate: "Status Update Date",
        remark: "Remark",
        updating: "Updating...",
        updateStatus: "Update Status",
    },
    mr: {
        selectStatus: "स्थिती निवडा",
        statusUpdateDate: "स्थिती अद्ययावत दिनांक",
        remark: "टिप्पणी",
        updating: "अद्ययावत होत आहे...",
        updateStatus: "स्थिती अद्ययावत करा",
    },
};
